import { z } from "zod";

export type Locations = z.infer<typeof LocationsSchema>;
export const LocationsSchema = z.object({
  cms_flag: z.boolean().nullable(),
  default_name: z.string(),
  hash_value: z.string().nullable(),
  id: z.number(),
  is_default_location: z.boolean(),
  is_room_asking: z
    .boolean()
    .nullable()
    .transform((value) => value ?? false),
  location_group_id: z.number(),
  name: z.string().nullable(),
  name_dict: z.string(),
  pms_name: z.string().nullable(),
  qr: z.string(),
});
